import React from 'react'
import styles from '../search.module.css'
import googleLogo from '../assets/google-logo.png'

export default function GoogleLogin() {
  const handleGoogleLogin = () => {
    console.log("Google Login triggered");
  };
   
    return (
      <div className={styles.loginWrapper}>
      <div className={styles.loginBox}>
        <h1 className={styles.loginTitle}>Login with Google</h1>
        <button className={styles.googleButton} onClick={handleGoogleLogin}>
          <img src={googleLogo} alt="Google Logo" className={styles.googleLogo} />
          Sign in with Google
        </button>
      </div>
    </div>
    )
}
